import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux"
import { clearGlobalAnnouncement } from "USERPROFILE/announcementSlice";
import { markReadAnnouncement } from "../../redux/features/notificationSlice"
import Close from "../../assets/default/images/close.png"

const GlobalAnnouncementPopup = () => {
    const [showAnnouncementAlert, setShowAnnouncementAlert] = useState(false);
    const [showAnnouncement, setShowAnnouncement] = useState(true);
    const { announcement } = useSelector((state) => state.announcement);
    
    const dispatch = useDispatch();
    // On notification read button click
    const readNotification = (id) => {
        setShowAnnouncement(false);
        setShowAnnouncementAlert(false);
        dispatch(clearGlobalAnnouncement());
        dispatch(markReadAnnouncement(id));
    };

    // Announcement modal
    const AnnouncementModal = ({ setShow, announcementData }) => {
        return (
            <div id="infoModal" className="overlay">
                <div className="popup2">
                    <div className="body">
                        <div className="group">
                            <div className="span12">
                                <div className="close-btn2 float-right">
                                    <img onClick={() => setShow(false)} src={Close} alt={"X"} />
                                </div>

                                <h4 className="float-left margin-bottom30 margin-top2">
                                    Announcement
                                </h4>
                            </div>
                            <div className="clear"></div>
                            <div className="span12">
                                <div className="overlay-content margin-bottom">
                                    <p> {announcementData && announcementData?.content}</p>
                                </div>
                            </div>
                            {announcement.readFlag === 0 && (
                                <div className="btn-center margin-top1">
                                    <button
                                        className="btn-primary  btn-margin"
                                        onClick={() =>
                                            readNotification(
                                                announcementData && announcementData.announcementId
                                            )
                                        }
                                    >
                                        I have read this
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            {showAnnouncement &&
                announcement &&
                announcement?.title &&
                new Date(announcement?.endDate) > new Date() &&
                new Date(announcement?.startDate) < new Date() &&
                announcement.readFlag === 0 && (
                    <AnnouncementModal
                        setShow={setShowAnnouncement}
                        announcementData={announcement}
                    />
                )}
            {showAnnouncementAlert && (
                <AnnouncementModal
                    setShow={setShowAnnouncementAlert}
                    announcementData={announcement}
                />
            )}
            {announcement &&
                announcement?.title &&
                new Date(announcement?.endDate) > new Date() &&
                new Date(announcement?.startDate) < new Date() && (
                    <div className="announcement-banner">
                        {announcement?.title}{" "}
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowAnnouncementAlert(true)}
                        >
                            <u>Learn more</u>
                        </span>
                    </div>
                )}
        </>
    )
}

export default GlobalAnnouncementPopup;